import { useEffect } from "react";

import type {
    ConversionRatesCategoryOverviewListData,
    ConversionRatesCategoryOverviewListParams,
} from "@similarweb/pro-api-client";
import Sentry from "@similarweb/sentry-logger";

import { useApiQuery } from "app/modules/api-client";

export const useConversionRateOverviewData = (
    params: ConversionRatesCategoryOverviewListParams,
    { enabled }: { enabled: boolean },
) => {
    const query = useApiQuery(
        {
            tag: "WebConversionRates",
            methodName: "conversionRatesCategoryOverviewList",
            options: { enabled, placeholderData: undefined },
        },
        params,
    );

    const { isError, error } = query;

    useEffect(() => {
        if (isError) {
            Sentry.errorTracker({
                e: error instanceof Error ? error : new Error("Conversion rate overview request failed"),
                message: "Failed to load conversion rate overview",
                level: "error",
            });
        }
    }, [isError, error]);

    // The endpoint returns an empty body when the category has no data,
    // so we normalize incomplete payloads to undefined and let the UI hide.
    const raw = query.data as Partial<ConversionRatesCategoryOverviewListData> | undefined;
    const data: ConversionRatesCategoryOverviewListData | undefined =
        raw && raw.totalConvertedVisits && raw.avgConversionRate
            ? (raw as ConversionRatesCategoryOverviewListData)
            : undefined;

    return { ...query, data };
};
